import React, { Component } from 'react';
import 'antd/dist/antd.css';
import {Row,Carousel,Col} from 'antd';
import Signup from '../../Components/Signup';
import '../../Stylesheet/carrier.scss';
// import Customersignup from '../../Images/Customersignup.png';

class driverSignup extends Component{
    render(){
        return(
            <div style={{maxHeight: '100px'}}>
        <Row>
          <Col span ={10} className="HomeSlider">
            <Carousel autoplay></Carousel>
          </Col>
          <Col span ={14} className="homeSection">
          <Signup registrationType="driver"/>
          </Col>
        </Row>
      </div>
            
        )
    }
}

export default driverSignup;